import React from 'react';
import { ArrowDown } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full py-20 px-4 md:py-32 bg-cream text-center overflow-hidden" data-id="element-55">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-56">
        <span className="inline-block py-1 px-3 rounded-full bg-sage/10 text-sage-dark text-sm font-bold tracking-wider mb-6 uppercase" data-id="element-57">
          Protocolo Vientre Plano & Energía 30-70
        </span>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-brown leading-tight mb-8" data-id="element-58">
          ¿Te despertás con la panza chata pero terminás el día teniendo que
          desabrocharte el botón del jean?
        </h1>

        <p className="text-xl md:text-2xl text-brown-light font-body leading-relaxed mb-10 max-w-2xl mx-auto" data-id="element-59">
          Descubrí el método de{' '}
          <span className="font-bold text-terracotta" data-id="element-60">"Reseteo del Vago"</span>{' '}
          para desinflamar tu abdomen y recuperar tu energía vital en solo 14
          días. Sin dietas imposibles y usando lo que ya tenés en tu cocina.
        </p>

        <div className="flex justify-center" data-id="element-61">
          <ArrowDown className="text-sage w-8 h-8 animate-bounce" data-id="element-62" />
        </div>
      </div>
    </section>;
}